const rolloutServiceConfig = {
    getRolloutSettings:'getFeatureSettings',
    setRolloutSettings:'createOrUpdateFeatureSettings'
};


export default rolloutServiceConfig;